const PLAYBOOK_VARIABLES = [
  { token: "{{agente}}", hint: "nome do agente" },
  { token: "{{nome}}", hint: "nome do lead" },
  { token: "{{numeroprocesso}}", hint: "número do processo" },
  { token: "{{polopassivo}}", hint: "polo passivo" },
  { token: "{{valor}}", hint: "valor estimado" },
];

export default function PlaybookVariableHint({ className = "" }) {
  return (
    <p className={`text-xs text-gray-500 ${className}`}>
      Variáveis:{" "}
      {PLAYBOOK_VARIABLES.map((variable, index) => (
        <span key={variable.token}>
          {index > 0 ? ", " : null}
          <span className="font-mono text-gray-700">{variable.token}</span>
          {` (${variable.hint})`}
        </span>
      ))}
      . <span className="font-mono text-gray-700">{"{{processo}}"}</span> repete o número do processo.
    </p>
  );
}
